import React, { useState } from "react";
import Navbar from "../layout/Header/Navbar";
import Layout from "../layout/Layout";
import PageHeader from "../components/common/PageHeader";
import FooterOne from "../layout/Footer/FooterOne";

const Orcador = () => {
  const [input, setInput] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPdfUrl("");
    try {
      const res = await fetch("https://pre-endback-a15c98f29747.herokuapp.com/api/generate-gpt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ description: input })
      });
      if (!res.ok) throw new Error("Erro ao gerar orçamento!");
      const data = await res.json();
      setPdfUrl(data.pdfUrl);
    } catch (err) {
      alert("Erro ao gerar orçamento!");
    }
    setLoading(false);
  };

  return (
    <Layout>
      <Navbar classOption="navbar-light" />
      <PageHeader title="Orçador" desc="Descreva o que você gostaria de orçar e receba um orçamento em PDF gerado por IA." />
      <div className="container py-5 d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="card shadow p-4" style={{ maxWidth: 600, width: '100%' }}>
          <h3 className="mb-4 text-center">Gerador de Orçamento com IA</h3>
          <form onSubmit={handleSubmit}>
            <textarea
              className="form-control mb-3"
              rows={5}
              placeholder="Descreva o que você gostaria de orçar..."
              value={input}
              onChange={e => setInput(e.target.value)}
              required
            />
            <button className="btn btn-primary w-100" type="submit" disabled={loading}>
              {loading ? "Gerando..." : "Gerar Orçamento"}
            </button>
          </form>
          {pdfUrl && (
            <div className="mt-4 text-center">
              <a href={pdfUrl} target="_blank" style={{ marginRight: "10px" }} rel="noopener noreferrer" className="btn btn-success">
                Baixar Orçamento em PDF
              </a>

              <a href={"https://stripe.com/br"} target="_blank" rel="noopener noreferrer" className="btn btn-success">
                Começar o seu projeto já!
              </a>
            </div>
          )}
        </div>
      </div>
      <FooterOne footerLight />
    </Layout>
  );
};

export default Orcador; 